export const cards = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20at%20airport%20casual%20fashion%20style%20warm%20natural%20lighting%20candid%20photography%20clean%20background%20editorial%20quality&width=640&height=400&seq=card-1&orientation=landscape',
    tag: '明星动态',
    title: '某顶流深夜现身三里屯，身旁神秘女子引猜测',
    desc: '凌晨1点左右被粉丝偶遇，全程低头快走。同行女子身份成谜，网友扒出多项细节线索。',
    time: '2小时前',
    views: '12.8万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20premiere%20event%20red%20carpet%20photographers%20crowd%20warm%20evening%20lighting%20glamorous%20atmosphere%20professional%20photography&width=640&height=400&seq=card-2&orientation=landscape',
    tag: '影视资讯',
    title: '《长安十二时辰》电影版官宣开机，原班人马回归',
    desc: '导演携编剧团队亮相开机仪式，透露电影版将采用全新叙事结构，视效全面升级，预计明年暑期上映。',
    time: '5小时前',
    views: '9.6万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20studio%20recording%20variety%20show%20stage%20colorful%20lighting%20performers%20interacting%20lively%20atmosphere%20professional%20production&width=640&height=400&seq=card-3&orientation=landscape',
    tag: '综艺热点',
    title: '《奔跑吧》新季首录路透曝光，飞行嘉宾阵容豪华',
    desc: '本季首期录制地点选在云南大理，路透显示多位当红艺人加盟。节目组回应将在下周举行发布会。',
    time: '8小时前',
    views: '7.3万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20concert%20stage%20singer%20performing%20dramatic%20lighting%20large%20audience%20energetic%20atmosphere%20professional%20live%20photography&width=640&height=400&seq=card-4&orientation=landscape',
    tag: '音乐圈',
    title: '周深2026巡回演唱会首站售罄，加场呼声高涨',
    desc: '开票仅3分钟全部售罄，创下本年度演唱会最快售罄纪录。主办方回应正在协调加场事宜。',
    time: '11小时前',
    views: '15.2万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20set%20ancient%20costume%20actors%20in%20traditional%20clothing%20warm%20cinematic%20lighting%20professional%20production%20atmosphere&width=640&height=400&seq=card-5&orientation=landscape',
    tag: '剧集热评',
    title: '《长相思》第二季首播口碑出炉，豆瓣开分8.9',
    desc: '延续第一季的高水准制作，剧情节奏更加紧凑。观众评价"每一帧都可以当壁纸"，预计将成为年度爆款。',
    time: '昨天',
    views: '18.5万',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20magazine%20photoshoot%20behind%20the%20scenes%20professional%20lighting%20elegant%20styling%20creative%20atmosphere%20editorial%20quality&width=640&height=400&seq=card-6&orientation=landscape',
    tag: '时尚前沿',
    title: '某小花登上国际大刊封面，造型被赞年度最佳',
    desc: '成为该杂志创刊以来最年轻的封面女星。造型团队透露整套搭配耗时三个月准备，多个高定品牌争相赞助。',
    time: '昨天',
    views: '6.9万',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20award%20ceremony%20winners%20holding%20trophies%20on%20stage%20warm%20spotlights%20celebratory%20atmosphere%20professional%20event%20photography&width=640&height=400&seq=card-7&orientation=landscape',
    tag: '奖项速递',
    title: '金鸡奖提名名单公布，新生代演员占比超六成',
    desc: '本届提名呈现明显的年轻化趋势，多位95后、00后演员入围重量级奖项。完整名单与专业分析已整理。',
    time: '2天前',
    views: '5.4万',
  },
];